<svelte:options accessors/>
<script>
    import NauiSelect from "../../../../naui/atoms/NauiSelect.svelte";
    import NauiInput from "../../../../naui/atoms/NauiInput.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";

</script>
<section>
    <fieldset>
        <legend>Datos del siniestro registrado</legend>
        <div class="grid-5 gap-1 mb-1">
            <NauiSelect label="Tipo de documento" options="[]" />
            <NauiInput label="No. Identificación" />
            <NauiInput label="Placa" />
            <NauiInput type="number" label="No. Radicado" />
        </div>
        <div class="py-1">
            <NauiButton caption="Continuar" color="accent" mode="solid" className="min-w-200px" />
        </div>
    </fieldset>
</section>
